import { api } from "boot/axios";
import { LocalStorage } from "quasar";

export const login = async ({commit}, form) => {
  try {
    const resp = await api.post('/auth/request_token/', form)
    api.defaults.headers.common['Authorization'] = `Token ${resp.data.access_token}`
    if (resp.data.user.access) {
      commit('setLogin', resp.data)
      LocalStorage.set('auth._token', resp.data.access_token)
      return Promise.resolve(true)
    } else {
      return Promise.reject('No tienes acceso')
    }
  } catch (error) {
    return Promise.reject('Correo / contraseña incorrecto')
  }
}

export const profile = async ({commit}, data) => {
  try {
    commit('setLogin', data)
  } catch (error) {
    console.log(error)
  }
}

export const logout = async ({commit}) => {
  try {
    await api.post('/auth/revoke_token/')
    delete api.defaults.headers.common["Authorization"]
    commit('setLogout')
    LocalStorage.remove('auth._token')
    return Promise.resolve(true)
  } catch (error) {
    delete api.defaults.headers.common["Authorization"]
    LocalStorage.remove('auth._token')
    return Promise.reject(error)
  }
}
